<template>
  <dialog-scroll
    :title="L10n('customer-remainder')"
    ref="dialog"
    :isLoading="isLoading"
  >
    <el-table
      :data="data"
      border
      style="width: 100%"
      stripe
      show-summary
      :sum-text="L10n('sum')"
      class="table-customer-reminder"
    >
      <template v-for="item in config">
          <el-table-column
            :key="item.id"
            :prop="item.field"
            :label="L10n(item.labelKey)"
            :sortable="item.sortable"
            :formatter="(row, column, celValue) => item.convertor ? item.convertor(celValue, row) : celValue"
          >
          </el-table-column>
        </template>
    </el-table>
    <template v-slot:footer>
      <button :disabled="data.length === 0" class="btn btn-size-s" @click="onExportToExcel">
        {{L10n('export-to-excel')}}
      </button>
    </template>
  </dialog-scroll>
</template>

<script>
import { ServicePayments } from '@/services/Payments'
import ExcelExporter from '@/components/ExcelExporter'

export default {
  name: 'index',
  components: {
    'dialog-scroll': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogScroll')
  },
  props: {
    title: {
      required: true
    },
    companyID: {
      required: true
    },
    tableConfig: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      isLoading: true,
      data: []
    }
  },
  computed: {
    config () {
      return this.tableConfig
    }
  },
  methods: {
    show () {
      this.$refs['dialog'].show()
      this.loadData()
    },
    close () {
      this.$refs['dialog-email'].close()
    },
    onExportToExcel () {
      const name = `${this.L10n('customer-remainder')} - payment - ${this.title}`
      const columns = this.config
        .map(({ field, labelKey, excelType, template }) => {
          return { field: field, title: this.L10n(labelKey), type: excelType || 's', width: 20, template }
        })
      ExcelExporter
        .export(name, columns, this.data, 'list')
    },
    async loadData () {
      this.isLoading = true
      this.data = []
      try {
        const { data: listPayments } = await ServicePayments.getAllByCustomer(this.companyID)
        this.data = listPayments
      } catch (e) {
        // this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="stylus">
.table-customer-reminder{
  &.el-table {
    td, th {
      padding: 5px 0;
    }
  }
}
</style>
